var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66797 7.66758C1.66797 7.44666 1.84705 7.26758 2.06797 7.26758H9.28906V8.66758H2.06797C1.84706 8.66758 1.66797 8.48849 1.66797 8.26758V7.66758Z",
    fill: "url(#paint0_linear_8176_2)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.46875 2.66602H13.932C14.1529 2.66602 14.332 2.8451 14.332 3.06602V3.66602C14.332 3.88693 14.1529 4.06602 13.932 4.06602H7.46875V2.66602Z",
    fill: "url(#paint1_linear_8176_2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66797 3.06602C1.66797 2.8451 1.84705 2.66602 2.06797 2.66602H7.46875V4.06602H2.06797C1.84706 4.06602 1.66797 3.88693 1.66797 3.66602V3.06602Z",
    fill: "url(#paint2_linear_8176_2)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6875 7.26758H13.932C14.1529 7.26758 14.332 7.44666 14.332 7.66758V8.26758C14.332 8.48849 14.1529 8.66758 13.932 8.66758H9.6875V7.26758Z",
    fill: "url(#paint3_linear_8176_2)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16797 4.66667H6.83464C6.74264 4.66667 6.66797 4.592 6.66797 4.5V2.16667C6.66797 2.07467 6.74264 2 6.83464 2H8.16797C8.25997 2 8.33464 2.07467 8.33464 2.16667V4.5C8.33464 4.592 8.25997 4.66667 8.16797 4.66667Z",
    fill: "url(#paint4_linear_8176_2)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.168 9.33268H8.83464C8.74264 9.33268 8.66797 9.25802 8.66797 9.16602V6.83268C8.66797 6.74068 8.74264 6.66602 8.83464 6.66602H10.168C10.26 6.66602 10.3346 6.74068 10.3346 6.83268V9.16602C10.3346 9.25802 10.26 9.33268 10.168 9.33268Z",
    fill: "url(#paint5_linear_8176_2)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.71484 11.9333H13.932C14.1529 11.9333 14.332 12.1124 14.332 12.3333V12.9333C14.332 13.1542 14.1529 13.3333 13.932 13.3333H5.71484V11.9333Z",
    fill: "url(#paint6_linear_8176_2)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66797 12.3336C1.66797 12.1127 1.84705 11.9336 2.06797 11.9336H6.28125V13.3336H2.06797C1.84706 13.3336 1.66797 13.1545 1.66797 12.9336V12.3336Z",
    fill: "url(#paint7_linear_8176_2)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.83203 14.0007H5.4987C5.4067 14.0007 5.33203 13.926 5.33203 13.834V11.5007C5.33203 11.4087 5.4067 11.334 5.4987 11.334H6.83203C6.92403 11.334 6.9987 11.4087 6.9987 11.5007V13.834C6.9987 13.926 6.92403 14.0007 6.83203 14.0007Z",
    fill: "url(#paint8_linear_8176_2)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8176_2",
    x1: 1.66797,
    y1: 7.96758,
    x2: 9.28906,
    y2: 7.96758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3385FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0066FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8176_2",
    x1: 25.2354,
    y1: 3.36602,
    x2: 7.85801,
    y2: 3.36602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#C2C8CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.966,
    stopColor: "#C4C9CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8176_2",
    x1: 1.66797,
    y1: 3.36602,
    x2: 7.46875,
    y2: 3.36602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3385FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0066FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8176_2",
    x1: 21.7106,
    y1: 7.96758,
    x2: 9.95092,
    y2: 7.96758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#C2C8CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.966,
    stopColor: "#C4C9CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8176_2",
    x1: 7.5013,
    y1: 2,
    x2: 7.5013,
    y2: 4.66667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0066FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0052CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_8176_2",
    x1: 9.5013,
    y1: 6.66602,
    x2: 9.5013,
    y2: 9.33268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0066FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0052CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_8176_2",
    x1: 28.0217,
    y1: 12.6333,
    x2: 6.20358,
    y2: 12.6333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#C2C8CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.966,
    stopColor: "#C4C9CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_8176_2",
    x1: 1.66797,
    y1: 12.6336,
    x2: 6.28125,
    y2: 12.6336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3385FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0066FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_8176_2",
    x1: 6.16536,
    y1: 11.334,
    x2: 6.16536,
    y2: 14.0007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0066FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0052CC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlider);
export default __webpack_public_path__ + "static/media/slider.9c3bf5f13b78f3bea03b0704f4b0ff62.svg";
export { ForwardRef as ReactComponent };